<template>
  <div class="dashboard-page">
    <div class="page-header">
      <h1>控制面板</h1>
      <p>欢迎使用肾数科技后台管理系统</p>
    </div>

    <!-- 统计概览 -->
    <div class="stats-overview">
      <div class="stat-card">
        <div class="stat-icon">
          <el-icon><User /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">18</div>
          <div class="stat-label">总用户数</div>
          <div class="stat-trend positive">+12% 本周</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <el-icon><Document /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">5</div>
          <div class="stat-label">知识库总量</div>
          <div class="stat-trend positive">+8% 本周</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <el-icon><TrendCharts /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">6</div>
          <div class="stat-label">今日活跃用户</div>
          <div class="stat-trend positive">+5% 昨日</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <el-icon><Bell /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">39</div>
          <div class="stat-label">消息通知</div>
          <div class="stat-trend neutral">0% 变化</div>
        </div>
      </div>
    </div>

   

    <!-- 最近活动 -->
    <div class="recent-activity">
      <div class="activity-header">
        <h3>最近活动</h3>
        <el-button type="text">查看全部</el-button>
      </div>
      <div class="activity-list">
        <div class="activity-item">
          <div class="activity-icon">
            <el-icon><User /></el-icon>
          </div>
          <div class="activity-content">
            <div class="activity-title">新用户注册</div>
            <div class="activity-desc">张三完成了注册</div>
            <div class="activity-time">2分钟前</div>
          </div>
        </div>

        <div class="activity-item">
          <div class="activity-icon">
            <el-icon><Document /></el-icon>
          </div>
          <div class="activity-content">
            <div class="activity-title">知识库更新</div>
            <div class="activity-desc">新增了5条肾病相关知识</div>
            <div class="activity-time">15分钟前</div>
          </div>
        </div>

        <div class="activity-item">
          <div class="activity-icon">
            <el-icon><Bell /></el-icon>
          </div>
          <div class="activity-content">
            <div class="activity-title">系统通知</div>
            <div class="activity-desc">系统维护完成</div>
            <div class="activity-time">1小时前</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const timeRange = ref('7')
</script>

<style scoped>
.dashboard-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  font-size: 28px;
  color: #1e293b;
  margin: 0 0 10px 0;
}

.page-header p {
  color: #64748b;
  margin: 0;
}

.stats-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.stat-label {
  color: #64748b;
  margin-bottom: 8px;
}

.stat-trend {
  font-size: 14px;
  font-weight: 500;
}

.stat-trend.positive {
  color: #10b981;
}

.stat-trend.negative {
  color: #ef4444;
}

.stat-trend.neutral {
  color: #6b7280;
}

.charts-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.chart-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-header h3 {
  margin: 0;
  color: #1e293b;
}

.chart-placeholder {
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
}

.chart-placeholder .el-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.recent-activity {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.activity-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.activity-header h3 {
  margin: 0;
  color: #1e293b;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  background: #f8fafc;
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #e0e7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6366f1;
}

.activity-content {
  flex: 1;
}

.activity-title {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.activity-desc {
  color: #64748b;
  margin-bottom: 4px;
}

.activity-time {
  font-size: 12px;
  color: #94a3b8;
}

@media (max-width: 768px) {
  .stats-overview {
    grid-template-columns: 1fr;
  }
  
  .charts-section {
    grid-template-columns: 1fr;
  }
}
</style> 